
import TechTeamsec from './techteamsec';


function TechTeamsMain() {
    return (
        <div id="tech-team">
            <TechTeamsec />
        </div>
    )
}
export default TechTeamsMain;